import { MAX_UPLOAD_FILE_COUNT, MIN_UPLOAD_FILE_COUNT } from '@common/types/templateFormFields';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useId } from 'react';

const FILE_COUNT_OPTIONS = Array.from(
    { length: MAX_UPLOAD_FILE_COUNT - MIN_UPLOAD_FILE_COUNT + 1 },
    (_, index) => MIN_UPLOAD_FILE_COUNT + index,
);

interface Props {
    value: number;
    disabled?: boolean;
    onChange: (fileCount: number) => void;
}

export default function UploadFileCountField({ value, disabled = false, onChange }: Props) {
    const labelId = useId();

    return (
        <FormControl sx={{ minWidth: 180 }} disabled={disabled}>
            <InputLabel id={labelId}>Max. number of files</InputLabel>
            <Select
                labelId={labelId}
                label="Max. number of files"
                value={value}
                onChange={(event) => onChange(Number(event.target.value))}
            >
                {FILE_COUNT_OPTIONS.map((count) => (
                    <MenuItem key={count} value={count}>
                        {count}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
